import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faCloudDownloadAlt} from '@fortawesome/pro-solid-svg-icons';
import {canManageSavedCartArchive} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionManageArchiveUnarchiveIcon = faCloudDownloadAlt;

/**
 * Manage saved cart assets archive
 * @param params
 * @returns Action
 */
export const cartSavedActionManageArchiveUnarchive = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-manage-archive-unarchive',
	cb: () =>
		dispatcher.trigger(CART_SAVED_EVENT.MANAGE_ARCHIVE_UNARCHIVE, savedCart),
	enableTest: () => canManageSavedCartArchive(savedCart),
	get label() {
		return CART_SAVED_ACTION_LABELS.MANAGE_ARCHIVE_UNARCHIVE;
	},
	icon: cartSavedActionManageArchiveUnarchiveIcon,
	...params,
});

export default cartSavedActionManageArchiveUnarchive;
